
export default {
  async getTeams ({ state, commit }) {
    const data = await this.$api.getTeams(state.currentPage)

    commit('SET_PAGES', data.pages)
    commit('SET_TEAMS', data.teams)
  }
}
